const reviews = (state = null, action) => {
    switch (action.type) {
        case "ADD_REVIEWS":
            return action.payload
        default:
            return state
    }
}

export default reviews;